import { FileErrorCodeEnum, FileUploadErrEnum, FileUploadErrType, ImageUploadErrType } from 'interface';
import store from 'redux/store';
import { toast } from 'react-toastify';

export const UploadImgErrToast = (e: ImageUploadErrType) => {
    const msg = store.getState().lang.attachFileErrorCode;
    const nonFieldErr = e.non_field_errors.map((i) => i.code);
    const fileErr = e.image.map((i) => i.code);
    if (nonFieldErr.includes(FileUploadErrEnum.no_workspace_or_user)) toast.error(msg.noWorkspaceOrUser);
    if (nonFieldErr.includes(FileUploadErrEnum.upload_size_limit)) toast.error(msg.uploadSizeLimit);
    if (fileErr.includes(FileErrorCodeEnum.not_allowed_extension)) toast.error(msg.notAllowedExtension);
    if (fileErr.includes(FileErrorCodeEnum.too_large_file)) toast.error(msg.tooLargeFile);
};

export const UploadFileErrToast = (e: FileUploadErrType) => {
    const msg = store.getState().lang.attachFileErrorCode;
    const nonFieldErr = e.non_field_errors.map((i) => i.code);
    const fileErr = e.file.map((i) => i.code);
    if (nonFieldErr.includes(FileUploadErrEnum.no_workspace_or_user)) toast.error(msg.noWorkspaceOrUser);
    if (nonFieldErr.includes(FileUploadErrEnum.upload_size_limit)) toast.error(msg.uploadSizeLimit);
    if (fileErr.includes(FileErrorCodeEnum.not_allowed_extension)) toast.error(msg.notAllowedExtension);
    if (fileErr.includes(FileErrorCodeEnum.too_large_file)) toast.error(msg.tooLargeFile);
};
